import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import Header from "../components/Header";

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    companyname: "",
    industryname: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [agreetoConditions, setAgreetoConditions] = useState(false);
  const handleCheckboxChange = (e) => {
  setAgreetoConditions(e.target.checked);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreetoConditions) {
      setError("Please agree to Terms & Conditions");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const requestData = {
        name: formData.name, // Map correctly
        email: formData.email,
        password: formData.password,
        company_name: formData.companyname,
        sector_industry: formData.industryname,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/user/signup`,
        requestData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Signup Successful:", response.data);

      navigate("/login", {
        state: { successMessage: "Signup request submitted! Please wait for approval." },
      });
    } catch (error) {
      console.error("Signup Error:", error);
      setError(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Header /> */}
      <div id="wrapper">
        <section className="signup-section d-flex align-items-center py-5 py-md-0">
          <div className="container signup-container pt60px">
            <div className="row">
              <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
                <div className="pe-md-5 text-center text-md-start">
                  <h1 className="fw-bold mb-4">Sign up now to get started.</h1>
                  <p className="color858c95 ft-18 lh-27 inter">Register to access all the features of our services. Manage your business in one place. It’s Free!</p>  
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-container mt-5 mt-md-0">
                  <h2 className="fw-bold mb-4">Sign Up</h2>

                  {error && <p className="text-danger">{error}</p>}

                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder=" "
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder=" "
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>


                    {/* Password Field */}
                    <div className="form-group">
                      <input
                        type="password"
                        className={`form-control ${formData.password ? "has-value" : ""}`}
                        id="password"
                        name="password"
                        autoComplete="new-password"
                        placeholder=" "
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="password">Password</label>
                    </div>


                    <div className="form-group">
                      <input
                        type="companyname"
                        className="form-control"
                        id="companyname"
                        name="companyname"
                        placeholder=" "
                        value={formData.companyname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="companyname">Company</label>
                    </div>


                    <div className="form-group">
                      <input
                        type="industryname"
                        className="form-control"
                        id="industryname"
                        name="industryname"
                        placeholder=" "
                        value={formData.industryname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="industryname">Industry</label>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">                      
                      <span className="stay-signed-in checkbox-container d-flex gap-3">
                        <input
                          id="persistent"
                          name="persistent"
                          type="checkbox"
                          checked={agreetoConditions}
                          onChange={handleCheckboxChange}
                        />
                        <label for="persistent">Agree to Term & Conditions</label>
                      </span>
                  </div>


                    <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-4 py-3" disabled={loading || !agreetoConditions}>
                      {loading ? "Submitting..." : "Sign Up"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>

                    <p className="mt-3 ft-14 lh-24 text-center">
                      Already have an account? {" "}
                      <span
                        className="login-link"
                        onClick={() => navigate("/login")}
                        style={{ cursor: "pointer", color: "red" }}
                      >
                        Login
                      </span>
                    </p>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Signup;
